import { CODE_STYLING } from '@mui/internal-core-docs/constants';

const stylingSolutionMapping = {
  [CODE_STYLING.TAILWIND]: 'tailwind',
  [CODE_STYLING.CSS]: 'css',
  [CODE_STYLING.SYSTEM]: 'system',
};

export default stylingSolutionMapping;
